import React, {useEffect, useMemo, useState} from "react";
import SearchSection from "../../../../components/search/SearchSection";
import Selector from "../../../../components/selector/Selector";
import {DISPOSE_ASSET_LIST_HEADER} from "../../../../components/table/header/Headers";
import {searchListener, searchWithChildren} from "../../../../components/commonmethod/simmsDrawerMethod";
import Search from "../../../../components/search/Search";
import {CodeSpecNum} from "../../../../constant/CodeSpecNum";
import {getIndividualSetting, resetIndividualSetting, setIndividualSetting} from "../../../../api/user/UserAccountService";
import {extractObject, initHeaderOrders, simmsColumnsToJsGridHeaders} from "../../../../components/commonmethod/CommonMethod";
import SimmsInputSearch from "../../../../components/input/SimmsInputSearch";
import SimmsDrawerSearch from "../../../../components/drawer/simms/SimmsDrawerSearch";
import SimmsJsGrid from "../../../../components/js-grid/SimmsJsGrid";
import {navigateWithChildTab, pickDetailTabTitle} from "../../../../components/pageTabs/pageTabsStorage";
import {useNavigate} from "react-router-dom";
import {useExcelDownloadClick} from "../../../../components/commonmethod/excelMethod";
import JsGridExcelGridOpenButton from "../../../../components/js-grid/JsGridExcelGridOpenButton";

function DisposeAssetListType({checked, data, date, dataHook, pageInfo}) {
    const navigate = useNavigate();
    const {handleSearch, handlePageSizeChange, saveConditions, refresh, handleGridPageChange} = dataHook;
    const handleDownloadClick = useExcelDownloadClick(saveConditions);

    const [header, setHeader] = useState({order: DISPOSE_ASSET_LIST_HEADER, exclude: []});
    const searchDate = {startDate: saveConditions.startDate ?? date.startDate, endDate: saveConditions.endDate ?? date.endDate};

    useEffect(() => {
        getIndividualSetting().then((r) => {
            initHeaderOrders(r, DISPOSE_ASSET_LIST_HEADER, setHeader, [], () => {}, () => {}, "dispose_asset");
        });
    }, []);

    const handleRowClick = (row) => {
        const id = row?.dispose?.id;
        if (id == null) return;
        navigateWithChildTab(navigate, {
            title: pickDetailTabTitle(row?.dispose, "자산폐기 상세"),
            url: `/lifecycle/dispose/${id}`,
        });
    };

    const disposeAssetJsGridHeader = useMemo(() => simmsColumnsToJsGridHeaders(header), [header]);
    const excelGridSearch = useMemo(() => extractObject(saveConditions), [saveConditions]);

    return (
        <div className="container-height">
            <Search
                refresh={refresh}
                entity="dispose_asset"
                searchConditions={saveConditions}
                handleSearch={handleSearch}
                handlePageSizeChange={handlePageSizeChange}
                pageInfo={pageInfo}
                size
                detail
                date={searchDate}
                searchBar={{placeHolder: "요청제목, 요청코드, 자산명"}}
            >
                <SearchSection>
                    <Selector
                        showLabel
                        auth
                        onChange={(value) => searchWithChildren(handleSearch, "disposeCode", extractObject(saveConditions), value)}
                        data={saveConditions.disposeCode}
                        parentKey={CodeSpecNum.DisposeRequestCode}
                        recursive
                        entity="code"
                        title="코드명"
                    />
                    <Selector
                        showLabel
                        auth
                        onChange={(value) => searchListener(handleSearch, "requester", extractObject(saveConditions), value)}
                        data={saveConditions.requester}
                        uniqueKey="requester"
                        entity="userAccount"
                        title="요청자"
                    >
                        <SimmsInputSearch type="TEXT" placeHolder="사용자명" />
                        <SimmsDrawerSearch showLabel title="부서" entity="department" target="department" recursive />
                        <SimmsDrawerSearch showLabel title="업체" entity="company" target="company" />
                    </Selector>
                    <Selector
                        showLabel
                        auth
                        onChange={(value) => searchListener(handleSearch, "user", extractObject(saveConditions), value)}
                        data={saveConditions.user}
                        uniqueKey="user"
                        entity="userAccount"
                        title="검수자"
                    >
                        <SimmsInputSearch type="TEXT" placeHolder="사용자명" />
                        <SimmsDrawerSearch showLabel title="부서" entity="department" target="department" recursive />
                        <SimmsDrawerSearch showLabel title="업체" entity="company" target="company" />
                    </Selector>
                </SearchSection>
            </Search>

            <div className="container-height-body">
                <SimmsJsGrid
                    loading={dataHook.loading}
                    resizable={true}
                    data={data}
                    theme="linear"
                    style={{minHeight: 0, height: "100%"}}
                    header={disposeAssetJsGridHeader}
                    onHeaderSave={(v) => setIndividualSetting({headers: {dispose_asset: v}})}
                    onHeaderReset={() => resetIndividualSetting("headers", "dispose_asset")}
                    enableRowSelection={true}
                    onRowClick={handleRowClick}
                    onPageChange={handleGridPageChange}
                    toolbarEnd={() => (
                        <div className="flex items-center gap-2">
                            <JsGridExcelGridOpenButton entityName="ExcelDisposedAssetsDto" search={excelGridSearch} />
                        </div>
                    )}
                />
            </div>
        </div>
    );
}

export default DisposeAssetListType;
